import { COLOR, dots, float } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'SAR',
  version: 2,
  label: 'Parabolic SAR',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 50,
  inputs: [float('acceleration', 0.02, 'Acceleration', 0, 1, 0.01), float('maximum', 0.2, 'Maximum', 0, 1, 0.01)],
  outputs: [dots('sar', 'SAR', COLOR.blue)],
  talib: { functions: ['SAR'], expr: 'SAR(high, low, acceleration={acceleration}, maximum={maximum})' },
  listed: true,
  tailSafe: false,
  lookback: () => 1,
}
export default def
